import { Component } from '@angular/core';
import { TreeComponent } from '../tree.component';
import { TreeService } from '../tree.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { TreeNode as PrimeNgTreeNode } from 'primeng/api';
import { GermplasmTreeService } from '../germplasm/germplasm-tree.service';
import { JhiEventManager } from '../../core-utils';

@Component({
    selector: 'jhi-design-crosses-tree-table',
    templateUrl: '../tree-table.component.html',
    providers: [{ provide: TreeService, useClass: GermplasmTreeService }]
})
export class DesignCrossesTreeComponent extends TreeComponent {

    title = 'global.browse.for.list';

    constructor(public service: TreeService,
                public activeModal: NgbActiveModal,
                public alertService: AlertService,
                public translateService: TranslateService,
                public modalService: NgbModal,
                public eventManager: JhiEventManager) {
        super(service, activeModal, alertService, translateService, modalService, eventManager);
        this.selectionMode = 'multiple';
        this.showAddToParentList = true;
    }

    onMoveSuccess(draggedNode: PrimeNgTreeNode, res: any) {
        draggedNode.data.isLocked = res.isLocked;
    }
}
